import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";
import { useHistory, useLocation } from "react-router-dom";

import classes from "./PageLayout.module.scss";

type PageLayoutProps = {
  heading: string;
  description?: string;
  children?: React.ReactNode;
  heightAuto?: boolean;
  dashboardPage?: boolean;
  displayArrowBack?: boolean;
};

const PageLayout: FC<PageLayoutProps> = ({
  heading,
  description,
  children,
  heightAuto,
  dashboardPage,
  displayArrowBack,
}) => {
  const hasDescription = !!description;

  const location = useLocation();
  const history = useHistory();
  const fromPage = (location.state as any)?.from;

  const handleClickArrowBack = () => {
    history.push(fromPage);
  };

  return (
    <div
      className={classes.container}
      style={{
        paddingTop: `${hasDescription || dashboardPage ? "40" : "24"}px`,
        height: `${heightAuto ? "auto" : "100vh"}`,
      }}
    >
      <div style={{ height: 80, marginTop: "4rem" }} />
      <div className={classes.wrapper}>
        <div>
          <Typography variant="h1" className={hasDescription || dashboardPage ? classes.headingExtra : classes.heading}>
            {heading}
          </Typography>

          {hasDescription ? <Typography className={classes.description}>{description}</Typography> : null}
        </div>
        {displayArrowBack && <KeyboardBackspaceIcon className={classes.iconBack} onClick={handleClickArrowBack} />}
      </div>
      {children}
    </div>
  );
};

export default PageLayout;
